const translate = (t, key, fallback) => {
  if (typeof t !== 'function') return fallback

  const translated = t(key)

  return translated === key ? fallback : translated
}

const statusKeys = (t) => ({
  Menunggu: translate(t, 'deliveryRequest.status.waiting', 'Menunggu Vendor'),
  Ditolak: translate(t, 'deliveryRequest.status.rejected', 'Ditolak'),
  Diterima: translate(t, 'deliveryRequest.status.accepted', 'Diterima'),
})

export default statusKeys
